export enum WindowEvent {
  RESIZE = 'resize',
  SCROLL = 'scroll'
}
